import React from 'react';
import readXlsxFile from 'read-excel-file';
import { Card, Button, Modal, Spinner } from 'react-bootstrap';
import { FaCloudUploadAlt, FaFileExcel, FaDownload, FaInfoCircle } from 'react-icons/fa';
import conciliation from '../../api/apiweb-conciliation.js';
import './Conciliation.scss';

function Conciliation() {
  const [modalDescarga, setModalDescarga] = React.useState(false);
  const [modalMensaje, setModalMensaje] = React.useState('');
  const [errorConcilation, setErrorConcilation] = React.useState(false);
  const [dragging, setDragging] = React.useState(false);
  const [fileName, setFileName] = React.useState('');

  const closeModal = () => setModalDescarga(false);

  const schema = {
    fechaemision: { prop: 'fechaemision', required: true },
    ticket: { prop: 'ticket', type: String, required: true },
  };

  const hiddenFileInput = React.useRef(null);

  const handleClick = () => hiddenFileInput.current.click();

  const processFile = async (fileUploaded) => {
    if (!fileUploaded) return;
    setFileName(fileUploaded.name);
    setModalMensaje('Procesando archivo…');
    setModalDescarga(true);
    setErrorConcilation(false);

    readXlsxFile(fileUploaded, { schema }).then(async ({ rows, errors }) => {
      if (errors.length > 0) {
        console.error(errors);
        setErrorConcilation(true);
        setModalMensaje('El archivo tiene errores de formato');
        return;
      }

      for (let i = 0; i < rows.length; i++) {
        if (rows[i].fechaemision instanceof Date) {
          rows[i].fechaemision = rows[i].fechaemision.toISOString().split('T')[0];
        }
      }

      try {
        const data = await conciliation(rows);
        setModalDescarga(false);
        setErrorConcilation(false);
        window.location = data;
      } catch (error) {
        console.error(error);
        setModalMensaje('Error en la conciliación de documentos');
        setErrorConcilation(true);
      }

      if (hiddenFileInput.current) hiddenFileInput.current.value = null;
    });
  };

  const handleChange = (event) => processFile(event.target.files[0]);

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const file = e.dataTransfer.files[0];
    if (file && (file.name.endsWith('.xlsx') || file.name.endsWith('.xls'))) {
      processFile(file);
    } else {
      setModalMensaje('Solo se aceptan archivos .xlsx');
      setErrorConcilation(true);
      setModalDescarga(true);
    }
  };

  return (
    <>
      <div className="Conciliation">
        <div className="page-header">
          <h1 className="page-title">Conciliación de Documentos</h1>
          <p className="page-subtitle">Sube un archivo Excel con boletas</p>
        </div>

        <Card className="search-card">
          <Card.Header className="search-card-header">
            <FaCloudUploadAlt className="me-2" />
            Subir archivo
          </Card.Header>
          <Card.Body>
            <div
              className={`dropzone ${dragging ? 'dropzone-dragging' : ''}`}
              onClick={handleClick}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClick(); }}
            >
              <FaCloudUploadAlt className="dropzone-icon" />
              <div className="dropzone-title">
                {fileName ? `Listo: ${fileName}` : 'Arrastra tu archivo aquí o haz clic para seleccionar'}
              </div>
              <div className="dropzone-hint">Solo archivos .xlsx</div>
              <input
                type="file"
                accept=".xlsx"
                ref={hiddenFileInput}
                onChange={handleChange}
                style={{ display: 'none' }}
              />
            </div>

            <div className="info-box">
              <FaInfoCircle className="info-icon" />
              <div>
                <strong>Columnas requeridas:</strong> <code>fechaemision</code> y <code>ticket</code>.
                <ul className="info-list">
                  <li><code>fechaemision</code>: fecha en formato <strong>dd-mm-aaaa</strong>.</li>
                  <li><code>ticket</code>: debe ser <strong>texto</strong>, no número.</li>
                </ul>
                <div className="info-sub">¿Necesitas un ejemplo? Descarga la plantilla.</div>
              </div>
              <Button
                variant="outline-primary"
                size="sm"
                href={process.env.PUBLIC_URL + '/conciliacion.xlsx'}
                download="conciliacion_ejemplo.xlsx"
                className="ms-auto"
              >
                <FaDownload className="me-2" /><FaFileExcel className="me-1" />Plantilla
              </Button>
            </div>
          </Card.Body>
        </Card>
      </div>

      <Modal show={modalDescarga} onHide={closeModal} centered>
        <Modal.Header closeButton={errorConcilation}>
          <Modal.Title>Conciliación de documentos</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          {!errorConcilation && <Spinner animation="border" variant="primary" className="mb-3" />}
          <div className="modal-message">{modalMensaje}</div>
        </Modal.Body>
        {errorConcilation && (
          <Modal.Footer>
            <Button variant="secondary" onClick={closeModal}>Cerrar</Button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}

export default Conciliation;
